import React from "react"
import { Button, Icon } from "antd"
import styled from "styled-components"

const MenuToggle = styled(Button)`
  position: fixed;
  top: 50px;
  left: -2px;
  z-index: 15;
`

export default props => {
  return (
    <MenuToggle
      type="primary"
      onClick={() => alert("toggle menu ples")}
      style={{ marginBottom: 16 }}
      {...props}
    >
      <Icon type={true ? "menu-unfold" : "menu-fold"} />
    </MenuToggle>
  )
}



// WEBPACK FOOTER //
// ./src/components/mobile-menu-toggle/mobile-menu-toggle.component.js